import React, { useEffect, useState } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import {
  FormInput,
  FormTemplate,
  FormTextArea,
  FormSelect,
  CustomSearchableSelect,
  SearchableFormSelect,
} from "../../../Components/Forms/InputTemplate";
import { FormProvider, useForm } from "react-hook-form";
import {
  ActionButtons,
  SupportButtons,
} from "../../../../global/components/Buttons/buttons";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllBranches,
  GetAlLEmployees,
  GetVendors,
} from "../../../../../utils/redux/Vendor/VendorSlice";
import { useLocation, useNavigate, useParams } from "react-router";
import {
  GetProcBeneficiaries,
  GetProcDepartment,
  UpdateProcRequsition,
} from "../../../../../utils/redux/Procurement/ProcurementSlice";
import Table from "../../../Components/Table/Table";
import { TableActionsDownload } from "../../../Components/Misc/Actions";
import { MaintenanceType } from "../../../../../utils/const/VehicleMaintenanceConst";
import {
  CreateMaintenanceRequisition,
  GetAllFleets,
  GetAllVehicleDocumentType,
} from "../../../../../utils/redux/Fleet/FleetSlice";
import {
  GetAssetComponent,
  GetAssetSingleRegister,
} from "../../../../../utils/redux/AssetsSetUp/AssetSetUpSlice";
import FleetFormUploadComponent from "../../../Components/Forms/FleetFormUploadComponent";
import { removeListData } from "../../../../../utils/functions/ResourceFunctions";
import { AssetAllocation_fleet } from "../../../../../utils/redux/Assets/AssetSlice";
import RequisitionBeneficiaries from "../../Procurement/Requisition/RequisitionBenficiaries";
import { toast } from "react-toastify";
import { useHrGetQuery } from "../../../../api/hrApi";

function AddAssetMaintenanceRequisition() {
  const dispatch = useDispatch();
  const location = useLocation()?.state;
  const [fleetItems, setFleetItems] = useState({});
  const { fleet } = useSelector((state) => state);
  const { asset_register, asset_component } = useSelector(
    (state) => state?.assetSetUp
  );
  const [vendorItems, setVendorItems] = useState({});
  const [userItems, setUserItems] = useState({});
  const [componentItems, setComponentItems] = useState({});
  const [setMaintenanceTypes] = useState({});
  const { isLoadingAction, all_vendors } = useSelector(
    (state) => state?.vendor
  );
  const { all_document_type } = useSelector((state) => state?.fleet);

  const [assetItems, setAssetItems] = useState({});

  const [uploadFile, setUploadFile] = useState(null);
  const [uploadDocument, setUploadDocument] = useState(
    location?.documents || []
  );

  const acq = asset_register?.responseObject;
  const allocatedAsset = useSelector(
    (state) => state?.assets?.asset_actions?.result || []
  );

    const { data: employees } = useHrGetQuery(`/Employee/GetAllEmployees?ApprovalStatus=0&PageSize=100000&PageNumber=1`)
  

  useEffect(() => {
    dispatch(
      AssetAllocation_fleet({
        pageSize: 100000,
        currentPage: 1,
        SortBy: 1,
        FilterBy: 2,
        // searchText : ""
      })
    );
    dispatch(
      GetAllFleets({
        pageSize: 100000,
        currentPage: 1,
        sort: 1,
      })
    );
    dispatch(
      GetVendors({
        filter: 0,
        PageSize: 10000,
        CurrentPage: 1,
        sort: 1,
      })
    );
    dispatch(
      GetAlLEmployees({
        pageSize: 100000,
        pageNumber: 1,
      })
    );
    dispatch(GetProcBeneficiaries());
    dispatch(GetProcDepartment());
    dispatch(GetAllBranches());
    dispatch(
      GetAssetComponent({
        // Name: "",
        CategoryId: 0,
        AssetClassId: 0,
        AssetSubClassId: 0,
        PageSize: 100000,
        CurrentPage: 1,
      })
    );

    dispatch(
      GetAllVehicleDocumentType({
        pageSize: 100000,
        currentPage: 1,
        sort: 0,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [acq]);

  const vendors = all_vendors?.result?.filter(
    (row) => row.businessNature === "Automobile Dealership"
  );

  const defaultData = {
    MaintenanceType: location?.MaintenanceType,
    ComponentId: location?.ComponentId,
    AssetId: location?.assetId,
    MaintenanceDate: location?.MaintenanceDate,
    Amount: location?.Amount,
    Purpose: location?.Purpose,
    Comment: location?.Comment,
    beneficiaries: location?.beneficiaryEl || [
      {
        branch: "",
        department: "",
        branchId: "",
        departmentId: "",
        beneficiaryName: "",
        Quantity: "",
        beneficiaryType: "",
      },
    ],
  };

  const formMethods = useForm({
    defaultValues: defaultData,
    mode: "all",
  });

  const {
    handleSubmit,
    getValues,
    setValue,
    reset,
    formState: { isValid },
  } = formMethods;

  const [flipData, setFlipData] = useState(getValues("RequisitionType") || 0);

  const { id } = useParams();

  const navigate = useNavigate();

  const submit = (data) => {
    const findAsset = allocatedAsset?.find((x) => x?.id === data?.AssetId);

    const formData = {
      ...data,
      id: id,
      RequestorId: userItems?.fleetOwnerId,
      RequestorName: userItems?.fleetOwnerName,
      AssetName: findAsset?.requisitionDetails,
      VendorId: vendorItems?.id,
      VendorName: vendorItems?.businessName,
      ComponentName: componentItems?.name,
    };

    const fileData = new FormData();
    const key = Object.keys(formData);

    key?.forEach((key, index) => {
      fileData.append(`${key}`, formData[key]);
    });

    const removedKey = ["beneficiaries", "vendors"];

    const removedUnwantedKey = key
      ?.map((x) => x)
      ?.filter((x) => !removedKey.includes(x));

    removedUnwantedKey?.forEach((key, index) => {
      fileData.append(`${key}`, formData[key]);
    });

    formData?.beneficiaries?.forEach((key, index) => {
      fileData.append(
        `Beneficiaries[${index}].department`,
        key?.department || ""
      );
      fileData.append(
        `Beneficiaries[${index}].departmentId`,
        key?.departmentId || ""
      );
      fileData.append(`Beneficiaries[${index}].quantity`, key?.quantity || 0);
      fileData.append(`Beneficiaries[${index}].branch`, key?.branch || "");
      fileData.append(`Beneficiaries[${index}].branchId`, key?.branchId || "");
      fileData.append(
        `Beneficiaries[${index}].beneficiaryName`,
        key?.beneficiaryName || ""
      );
      fileData.append(
        `Beneficiaries[${index}].beneficiaryType`,
        +key?.beneficiaryType
      );
    });

    uploadDocument.forEach((element, index) => {
      fileData.append(
        `uploadDocuments[${index}].file`,
        element?.file,
        element?.fileName
      );
      fileData.append(`uploadDocuments[${index}].fileName`, element?.fileName);
    });

    uploadDocument?.map((x) => x)?.filter((x) => "file" in x);

    location
      ? dispatch(UpdateProcRequsition(fileData))?.then((res) => {
          if (res?.payload?.successful === true) {
            reset();
            navigate(`../${res?.payload?.responseObject?.uuId}/view`);
            return;
          }
          toast.error(res?.payload?.statusMessage)

        })
      : dispatch(CreateMaintenanceRequisition(fileData))?.then((res) => {
          if (res?.payload?.successful === true) {
            reset();
            navigate(`../${res?.payload?.responseObject?.uuId}/view`);
            return;
          }
          toast.error(res?.payload?.statusMessage)
        });
  };

  // console.log("assetItems", assetItems);

  return (
    <PageLayout
      title={
        location ? "Edit Requisition" : "Add Asset Maintenance Requisition"
      }
      hasBack={true}
    >
      <FormProvider {...formMethods}>
        <FormTemplate handleSubmit={handleSubmit(submit)}>
          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>
              Maintenance <br /> Information
            </h4>
            <div className={DashboardStyle.inputs_group}>
              {!location && (
                <>
                  <div>
                    <CustomSearchableSelect
                      title={"Asset Name"}
                      camelCase={"AssetId"}
                      placeholder={"select"}
                      isOptional={true}
                      options={
                        allocatedAsset &&
                        allocatedAsset?.map?.((x, index) => ({
                          label: `${x?.beneficiaryName} - ${x?.requisitionDetails}`,
                          value: x?.id,
                          object: x,
                        }))
                      }
                      moreRegister={{
                        onChange: (e) => {
                          const isFound = allocatedAsset?.find(
                            (x) => +e.value === x?.id
                          );
                          setAssetItems(isFound);
                        },
                      }}
                    />

                    <FormSelect
                      title={"Maintenance Type"}
                      camelCase={"MaintenanceType"}
                      placeholder={"Auto Generated"}
                      disabled={true}
                      array={Object.entries(MaintenanceType)?.map?.(
                        ([key, value]) => (
                          <option key={key} value={value}>
                            {key}
                          </option>
                        )
                      )}
                    />
                  </div>

                  <div>
                    <FormSelect
                      title={"Component"}
                      camelCase={"ComponentId"}
                      placeholder={"select"}
                      isOptional={false}
                      array={asset_component?.responseObject?.map?.(
                        (x, index) => (
                          <option key={index} value={x?.id}>
                            {x?.name}
                          </option>
                        )
                      )}
                      moreRegister={{
                        onChange: (e) => {
                          const isFound = asset_component?.responseObject?.find(
                            (x) => +e.target.value === x?.id
                          );
                          setComponentItems(isFound);
                          return;
                        },
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          </section>
          {/* <RequisitionBeneficiaries
            assetItems={assetItems}
            flipData={flipData}
          /> */}
          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>
              Other <br /> Information
            </h4>
            <div className={DashboardStyle.inputs_group}>
              {!location && (
                <>
                  <div>
                    <FormSelect
                      title={"Vendor Name"}
                      camelCase={"VendorId"}
                      placeholder={"select vendor"}
                      array={all_vendors?.result?.map?.((x, index) => (
                        <option key={index} value={x?.id}>
                          {x?.businessName}
                        </option>
                      ))}
                      moreRegister={{
                        onChange: (e) => {
                          const isFound = all_vendors?.result?.find(
                            (x) => +e.target.value === x?.id
                          );
                          setVendorItems(isFound);
                          return;
                        },
                      }}
                    />
                    <FormSelect
                      title={"Requested By"}
                      camelCase={"RequestorId"}
                      placeholder={"select requestor"}
                      array={
                        // fleet?.all_fleets?.pageItems
                        employees?.result?.map?.((x, index) => (
                        <option key={index} value={x?.initiatorId}
                        // value={x?.id}
                        
                        >
                          {x?.initiatorName}
                          {/* {x?.fleetOwnerName} */}
                        </option>
                      ))}
                      moreRegister={{
                        onChange: (e) => {
                          // fleet?.all_fleets?.pageItems?
                          const isFound = employees?.result?.find(
                            (x) => +e.target.value === x?.id
                          );
                          setUserItems(isFound);
                          return;
                        },
                      }}
                    />
                    <FormInput
                      title={"Maintenance Date"}
                      camelCase={"MaintenanceDate"}
                      placeholder={"maintenance date"}
                      type="date"
                    />
                    <FormInput
                      title={"Amount"}
                      camelCase={"Amount"}
                      placeholder={"enter amount"}
                    />
                  </div>
                  <div className={DashboardStyle.textbox_lg}>
                    <FormTextArea
                      title={"Purpose"}
                      isOptional={false}
                      camelCase={"Purpose"}
                      placeholder={"enter description of the vehicle"}
                      type="textbox"
                    />
                  </div>
                </>
              )}
            </div>
          </section>
          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>
              Additional <br /> Information
            </h4>
            <div className={DashboardStyle.inputs_group_no_grid}>
              <div>
                <FormTextArea
                  title={"Other (Optional)"}
                  isOptional={true}
                  camelCase={"Comment"}
                  placeholder={"enter other information"}
                  type="textbox"
                />
              </div>
            </div>
          </section>
          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>
              Uploads supporting <br /> document
            </h4>
            <FleetFormUploadComponent
              documentList={all_document_type?.data?.map((x) => ({
                name: x?.title,
                value: x?.uuId,
              }))}
              uploadFile={uploadFile}
              setUploadFile={setUploadFile}
              setUploadDocument={setUploadDocument}
              uploadDocument={uploadDocument}
              isOptional={false}
            />
          </section>
          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>Uploaded</h4>
            <div
              className={` ${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads} `}
            >
              {uploadDocument?.length === 0 ? (
                <p>No Record Available</p>
              ) : (
                <Table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>File Name</th>
                      <th>File Type</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {uploadDocument?.map?.((x, index) => {
                      return (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{x?.fileName}</td>
                          <td style={{ textTransform: "uppercase" }}>
                            {x?.file?.type?.split("/")[1]}
                          </td>
                          <td>
                            <TableActionsDownload
                              file={x?.file?.file}
                              actions={() =>
                                removeListData({
                                  value: index,
                                  list: uploadDocument,
                                  setList: setUploadDocument,
                                })
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              )}
            </div>
          </section>
          <div className={DashboardStyle.button_cage}>
            <ActionButtons
              isLoading={isLoadingAction}
              disabled={!isValid}
              className={DashboardStyle?.button_cage_weight}
            >
              Submit
            </ActionButtons>
          </div>
        </FormTemplate>
      </FormProvider>
    </PageLayout>
  );
}

export default AddAssetMaintenanceRequisition;
